import { useState } from 'react'
import DownArrow from '../SvgComponents/DownArrow';
import { motion } from 'framer-motion'

function SiteSettingsBar(
    props: 
        {
            setWebsiteLanguageFunction: Function
        }
) {

    const website_language = localStorage.getItem("website_language");
    const [languageDropdown, setLanguageDropdown] = useState<boolean>(false);
    const [arrowAngle, setArrowAngle] = useState<number>(0);

    function activateDropdown() {
        setArrowAngle(180);
        setLanguageDropdown(true);
      }
    
      function deactivateDropdown() {
        setArrowAngle(0);
        setLanguageDropdown(false);
      }
  
      function toggleDropdown() {
          if(languageDropdown === false) {
              activateDropdown()
          }
          else if(languageDropdown === true) {
              deactivateDropdown()
          }
      }

    return (
        <div
            className="w-full
                      bg-[#054164]
                      p-2
                      flex justify-center items-center
                      border-t-[1px] border-slate-100/30"
        >
            <div
                className="w-full mobile:w-[80%] flex items-center"
            >
                <div
                    className="flex flex-col mobile:flex-row mobile:items-center w-full mobile:w-fit"
                >
                    <div
                        className={`w-full 
                                    flex items-center
                                    mb-2 mobile:mb-0`}      
                    >
                        <p className="text-white mr-2 
                                    w-full
                                    flex
                                    ">
                            {website_language === "EN" ? "Select language" : "Selectează limba"}
                            <span className="hidden mobile:block">:</span>
                        </p>
                        <div
                            className='stroke-white
                                      flex items-center justify-center mobile:hidden
                                      hover:bg-white/20
                                      p-1
                                      rounded-md
                                      cursor-pointer'
                        >
                            <motion.div
                                animate={{
                                    rotate: arrowAngle
                                }}
                                onClick={toggleDropdown}
                                className="flex items-center justify-center
                                        w-full h-full"
                            >
                                <DownArrow />
                            </motion.div>
                        </div>
                    </div>
                    <div
                        className={`hidden mobile:flex flex-col mobile:flex-row 
                                    mobile:items-center
                                    w-full`}
                    >
                        <div
                            className={`p-1 pt-[2px] pb-[2px]
                                    cursor-pointer
                                    w-full mobile:w-fit 
                                    mb-2 mobile:mb-0
                                    ${website_language === "EN" ? "text-[#054164]" : "text-white"}
                                    ${website_language === "EN" ? "bg-white" :"bg-transparent hover:bg-white/20"}
                                    border-[1px] border-transparent hover:border-white
                                    rounded-md
                                    mr-2`}
                            onClick={() => props.setWebsiteLanguageFunction("EN")}
                        >
                            {website_language === "EN" ? "English" : "Engleză"}
                        </div>
                        <div
                            className={`p-1 pt-[2px] pb-[2px]
                                    cursor-pointer
                                    w-full mobile:w-fit 
                                    mb-2 mobile:mb-0
                                    ${website_language === "RO" ? "text-[#054164]" : "text-white"}
                                    ${website_language === "RO" ? "bg-white" :"bg-transparent hover:bg-white/20"}
                                    border-[1px] border-transparent hover:border-white
                                    rounded-md`}
                            onClick={() => props.setWebsiteLanguageFunction("RO")}
                        >
                            {website_language === "EN" ? "Romanian" : "Română"}
                        </div>
                    </div>
                    <div
                        className={`flex flex-col mobile:hidden
                                    mobile:items-center
                                    w-full
                                    ${languageDropdown === false ? "hidden" : "flex"}`}
                    >
                        <div
                            className={`p-1 pt-[2px] pb-[2px]
                                    cursor-pointer
                                    w-full mobile:w-fit 
                                    mb-2 mobile:mb-0
                                    ${website_language === "EN" ? "text-[#054164]" : "text-white"}
                                    ${website_language === "EN" ? "bg-white" :"bg-transparent hover:bg-white/20"}
                                    border-[1px] border-transparent hover:border-white
                                    rounded-md
                                    mr-2`}
                            onClick={() => props.setWebsiteLanguageFunction("EN")}
                        >
                            {website_language === "EN" ? "English" : "Engleză"}
                        </div>
                        <div
                            className={`p-1 pt-[2px] pb-[2px]
                                    cursor-pointer
                                    w-full mobile:w-fit 
                                    mb-2 mobile:mb-0
                                    ${website_language === "RO" ? "text-[#054164]" : "text-white"}
                                    ${website_language === "RO" ? "bg-white" :"bg-transparent hover:bg-white/20"}
                                    border-[1px] border-transparent hover:border-white
                                    rounded-md`}
                            onClick={() => props.setWebsiteLanguageFunction("RO")}
                        >
                            {website_language === "EN" ? "Romanian" : "Română"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SiteSettingsBar